
const FeaturedPost = () => {
  return (
    <section className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="text-teal-600 font-semibold">Featured Article</span>
          <h2 className="text-3xl font-bold text-gray-900 mt-2">Latest Insights</h2>
        </div>

        <div className="bg-gray-50 rounded-xl overflow-hidden hover:shadow-lg transition-shadow">
          <div className="grid lg:grid-cols-2 gap-0">
            <div className="order-2 lg:order-1 p-8 lg:p-12 flex flex-col justify-center">
              <div className="flex items-center gap-4 mb-4">
                <span className="bg-teal-100 text-teal-800 px-3 py-1 rounded-full text-sm font-medium">
                  Global Strategy
                </span>
                <span className="text-gray-500 text-sm">December 15, 2024</span>
              </div>
              
              <h3 className="text-3xl font-bold text-gray-900 mb-4">
                The Complete Guide to E-Commerce Expansion in 2025
              </h3>
              
              <p className="text-lg text-gray-600 mb-6 leading-relaxed">
                As we enter 2025, the landscape of international e-commerce continues to evolve rapidly. 
                New regulations, emerging markets, and technological advances are reshaping how businesses 
                approach global expansion. Here's everything you need to know to stay ahead.
              </p>
              
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <img 
                    src="https://public.readdy.ai/ai/img_res/768ee16a080826c57b0732fb2766768e.jpg"
                    alt="Sarah Chen"
                    className="w-12 h-12 rounded-full object-cover mr-4"
                  />
                  <div>
                    <div className="font-semibold text-gray-900">Sarah Chen</div>
                    <div className="text-sm text-gray-600">Global Strategy Expert</div>
                  </div>
                </div>
                
                <button className="text-teal-600 hover:text-teal-700 font-semibold whitespace-nowrap">
                  Read Full Article →
                </button>
              </div>
            </div>
            
            <div className="order-1 lg:order-2">
              <img 
                src="https://readdy.ai/api/search-image?query=Global%20e-commerce%20expansion%20strategy%20visualization%20with%20world%20map%20and%20digital%20commerce%20elements%2C%20international%20business%20growth%20charts%20and%20global%20market%20analysis%2C%20modern%20business%20strategy%20illustration&width=600&height=500&seq=featured-blog&orientation=landscape"
                alt="Global E-Commerce Strategy"
                className="w-full h-full object-cover min-h-80"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturedPost;
